import {React, useState}from "react";
import { Div, Button, Input, DivResult } from "./styles/search-style";
import TaskBarComponent from "./TaskBarComponent";
import Cookies from "universal-cookie";
import SearchResults from "./SearchResults";
const cookies = new Cookies();



function Search() {
    const [search, setSearch] = useState("");
    const [searchResponseData, setSearchResponseData] = useState([]);

    const searchText = (e) => {
        setSearch(e.target.value);
    }

    const submitSearch = async(e) => {
        e.preventDefault();
        const REACT_APP_BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
        const token = cookies.get("token");
        const response = await fetch(REACT_APP_BACKEND_URL+'/search?search='+search, {
            method: 'GET',
            headers : {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${token}`,
            },
        });
        if (response.ok) {
            setSearchResponseData( await response.json());
        } else {
            console.error('Failed to find data');
        }
    }


    return (
        <div className="Search">
            <TaskBarComponent/>
            <Div className="Search">
                <Input placeholder="Search" onChange={searchText} />
                <Button onClick={submitSearch}>Search</Button>
            </Div>
            <DivResult className="Search-Results">
                <SearchResults searchResponseData={searchResponseData} />
            </DivResult>
        </div>
    );
}

export default Search;

